// A value the collector picks with one key, once its event type is chosen.
export interface HotkeyOption<T> {
  value: T;
  label: string;
  hotkey: string;
}

export function optionForHotkey<T>(
  options: HotkeyOption<T>[],
  keyCode: number
): T {
  return options.find(
    (option) => option.hotkey.toUpperCase().charCodeAt(0) === keyCode
  )?.value;
}
